import { localDatabaseUrls } from "../backend/constants";
import { postAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

export const uploadDCCostManualPullFile = async ({ file } = {}) => {
  if (!file) {
    AlertManager.error("Choose a spreadsheet to upload.", { contactSupport: false });
    return null;
  }

  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const formData = new FormData();
  formData.append("file", file);
  if (!tokenInfo?.username) {
    AlertManager.error("Username is required to upload the file.", { contactSupport: false });
    return null;
  }
  formData.append("uploadedBy", tokenInfo.username);

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.dcCostUploadAsync}`;

  try {
    const response = await postAPI(apiUrl, formData, tokenInfo);

    if (response?.ok) {
      return response;
    }

    const errorData = await response?.json?.().catch(() => ({}));
    AlertManager.error(errorData?.message || "Unable to upload DC Cost file.", {
      contactSupport: false,
    });
    return response;
  } catch (error) {
    AlertManager.error("Unable to upload DC Cost file.", { contactSupport: false });
    return null;
  }
};

export default uploadDCCostManualPullFile;
